import { useAuth0 } from '@auth0/auth0-react';
import { getQueryParam, useQueryParam } from '@mi-front/core';
import { useCallback } from 'react';

/**
 * Returns a function that starts the Auth0 Universal Login redirect,
 * preserving redirect_to (return path) and email (login_hint) from the URL.
 */
export function useAuth0LoginRedirect() {
  const redirectTo = useQueryParam('redirect_to');
  const { loginWithRedirect } = useAuth0();

  return useCallback(() => {
    return loginWithRedirect({
      appState: { returnTo: redirectTo || '/' },
      authorizationParams: {
        login_hint: getQueryParam('email') ?? undefined,
      },
    });
  }, [loginWithRedirect, redirectTo]);
}
